import React from 'react';

interface IAdvertissementProps {
    description: string;
    title: string;
    url: string;
    buttonLabel: string;
}

export function Advertissement(content: IAdvertissementProps) {
    return (
        <article className="advertissement">
            <h2 className="advertissement__title">{content.title}</h2>
            <p className="advertissement__description">{content.description}</p>
            <a
                className="btn-myActiris__themed"
                href={content.url}
                target="_blank"
                rel="noopener noreferrer"
            >
                <i className="icon-user"></i>
                {content.buttonLabel}
            </a>
        </article>
    );
}
